import * as moment from 'moment'
import {
  ShippingsService
} from '@/common/api.service'
import {
  FETCH_SHIPPINGS,
  RESET_SHIPPINGS
} from './actions.type'
import {
  FETCH_START,
  FETCH_END,
  FETCH_END_INFINITE,
  UPDATE_SHIPPING_IN_LIST
} from './mutations.type'

const state = {
  shippings: [],
  isLoading: false,
  shippingsCount: 0
}

const getters = {
  shippingsCount (state) {
    return state.shippingsCount
  },
  shippings (state) {
    return state.shippings
  },
  isLoading (state) {
    return state.isLoading
  }
}

const actions = {
  [FETCH_SHIPPINGS] ({ commit }, params) {
    if (!params.infiniteScroll && !params.updating) {
      commit(FETCH_START)
    }
    return ShippingsService.query(params.type, params.filters)
      .then(({ data }) => {
        let collection = { shippings: data.data, shippingsCount: data.pagination.total }
        if (!params.infiniteScroll) {
          commit(FETCH_END, collection)
        } else {
          commit(FETCH_END_INFINITE, collection)
        }
      })
      .catch((error) => {
        throw new Error(error)
      })
  },
  [RESET_SHIPPINGS] ({ commit }, params) {
    let collection = { shippings: {}, shippingsCount: 0 }
    commit(FETCH_END, collection)
  }
}

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_START] (state) {
    state.isLoading = true
  },
  [FETCH_END] (state, { shippings, shippingsCount }) {
    state.shippings = shippings
    if (typeof shippings !== 'undefined') {
      if (shippings.length > 0 && typeof shippings[0].scheduled_date !== 'undefined') {
        state.shippings = state.shippings.map((shipping) => {
          shipping.created_at = moment.utc(shipping.created_at)
          shipping.scheduled_date = moment.utc(shipping.scheduled_date) || null
          return shipping
        })
      }
    }
    state.shippingsCount = shippingsCount
    state.isLoading = false
  },
  [FETCH_END_INFINITE] (state, { shippings, shippingsCount }) {
    state.shippings = state.shippings.concat(shippings)
    state.shippingsCount = shippingsCount
    state.isLoading = false
  },
  [UPDATE_SHIPPING_IN_LIST] (state, data) {
    state.shippings = state.shippings.map((shipping) => {
      if (shipping.slug !== data.slug) { return shipping }
      // We could just return data, but it seems dangerous to
      // mix the results of different api calls, so we
      // protect ourselves by copying the information.
      shipping.favorited = data.favorited
      shipping.favoritesCount = data.favoritesCount
      return shipping
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
